import { Button, message, Modal } from "antd";
import React, { useState } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import configurationManagementService from "@services/configuationManagement.service";

const { confirm } = Modal;

const DeleteAlert = ({ id, updateDataSource }) => {
  const [loading, setLoading] = useState(false);

  async function handleDelete() {
    setLoading(true);
    try {
      await configurationManagementService.deleteAlert({ id });
      setLoading(false);
      updateDataSource();
    } catch (err) {
      setLoading(false);
      message.error("action has error deleting Alert");
      console.log(err);
    }
  }

  function handleClick() {
    confirm({
      title: "Delete Alert",
      icon: <ExclamationCircleOutlined />,
      content: "Do you Want to delete these items?",
      onOk() {
        handleDelete();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  }

  return (
    <Button
      type="text"
      htmlType="button"
      shape="circle"
      disabled={loading}
      onClick={handleClick}
      size="small"
      className="inline-flex justify-center items-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
          clipRule="evenodd"
        />
      </svg>
    </Button>
  );
};

export default DeleteAlert;
